import React, {Component} from "react";
import {closeAlert} from "../../../actions/commonsActions";
import {goBack, push} from "connected-react-router";
import {USER_ROLES} from "../../../helpers/constants";
import {connect} from "react-redux";
import Datetime from "react-datetime";
import {
    fetchPromoterSettings,
    saveNewPromoterSettings,
    updateSinglePromoterSettings
} from "../../../actions/promoter/promoterSettingsActions";
import {Alert, Button, Card, CardBody, CardTitle, FormGroup, Input, Label, Media} from "reactstrap";
import {I18n} from "../../../I18n/components/promoter";
import spinner from "../../../assets/images/spinner.gif";
import promoterValidator from "../../../helpers/promoterValidator";
import CommonValidator from "../../../helpers/CommonValidator";
import moment from "moment";
import {isPromoterPermission} from "../../../helpers/companyService";
import swal from "sweetalert";

const DEFAULT_SCREEN_BRIGHTNESS = 50;

class PromoterSettings extends Component {

    constructor(props) {
        super(props);
        this.state = {
            settings: {
                companyId: null,
                turnOnTime: null,
                turnOffTime: null,
                priceTagUrl: null,
                screenBrightness: null,
            },
            screenBrightnessEnabled: false,
            isSavingDisabled: false,
        }
        this.validators = promoterValidator(props.lang).settingsValidator;
        this.commonValidator = new CommonValidator(this.validators);
    }

    componentDidMount() {
        (async () => {
            const {lang, company, authority} = this.props;

            if (!isPromoterPermission(company, authority)) {
                await swal(I18n[lang].contactUsToAccessThis, '', 'error')
                    .then(() => this.props.goBack())
                return;
            }

            await this.fetchSettings()
        })();
    }

    fetchSettings = async () => {
        const {company} = this.props;
        return await this.props.fetchSettings({companyId: company.id})
            .then(res => {
                if (res) {
                    this.setState({
                        settings: this.props.promoterSettings,
                        screenBrightnessEnabled: this.props.promoterSettings.screenBrightness != null
                    });
                }
            })
    }

    onInputChange = event => {
        const name = event.target.name;
        const value = event.target.value;
        this.onFieldChange(name, value);
    };

    onFieldChange = (propertyName, value) => {
        this.commonValidator.checkField(propertyName, value);
        this.setState(state => ({
            settings: Object.keys(state.settings).reduce((res, key) => {
                if (key === propertyName) {
                    res[key] = moment.isMoment(value)
                        ? value.format('HH:mm')
                        : value;
                } else {
                    res[key] = state.settings[key];
                }
                return res
            }, {})
        }));
    }

    onScreenBrightnessEnabledChange = event => {
        const target = event.target;
        const checked = target.checked;
        this.setState({
            screenBrightnessEnabled: checked,
        })
        this.onFieldChange('screenBrightness',
            checked ? DEFAULT_SCREEN_BRIGHTNESS : null);
    }

    onClearField = propertyName => {
        this.onFieldChange(propertyName, null);
    }

    handleSubmit = async (event) => {
        const {settings, isSavingDisabled} = this.state;
        const {promoterSettings, company} = this.props;
        if (isSavingDisabled) return;
        if (event) {
            event.preventDefault();
        }
        if (this.commonValidator.isValid()) {
            await this.setState({isSavingDisabled: true});

            const promise = promoterSettings
                ? this.props.updateSettings(settings)
                : this.props.saveSettings({
                    ...settings,
                    companyId: company.id
                });
            await promise.then(async () => {
                await this.fetchSettings();
            }).catch(error => {
                console.log(error.statusText);
            });

            await this.setState({isSavingDisabled: false});
        }
    };

    renderDateTime = fieldName => {
        const {lang} = this.props;
        const {settings} = this.state
        return (
            <Datetime
                id={fieldName}
                className="promoter-data-filter"
                locale={lang}
                timeFormat="HH:mm"
                dateFormat={false}
                inputProps={{
                    placeholder: "HH:mm",
                    readonly: true
                }}
                onChange={value => this.onFieldChange(fieldName, value)}
                closeOnSelect={true}
                value={settings[fieldName]}
            />
        );
    }

    renderClearButton = onClearFieldName => {
        const {lang} = this.props;
        return (
            <Button
                color="primary"
                type="button"
                className="ml-2"
                onClick={() => this.onClearField(onClearFieldName)}
            >
                {I18n[lang].reset}
            </Button>
        );
    }

    render() {
        const {lang, loading, alert} = this.props;
        const {isSavingDisabled, screenBrightnessEnabled, settings} = this.state;
        return (
            <div>
                {/*----------------------- alerts -----------------------------------*/}
                <Alert
                    color={`${alert.alert.status}`}
                    isOpen={alert.isOpen || false}
                >
                    {alert.isOpen ? `${alert.alert.message}` || "Failed" : ''}
                </Alert>
                <Card>
                    <CardTitle className="mb-0 p-3 border-bottom bg-light">
                        <div>
                            <i className="mdi mdi-settings mr-2"/>
                            {I18n.promoterTitleBeginning + I18n[lang].settings}
                        </div>
                    </CardTitle>
                    <CardBody>
                        <div className="text-center">
                            {
                                loading || isSavingDisabled
                                    ? <Media
                                        className="w-8em"
                                        object
                                        src={spinner}
                                        alt="loading spinner"
                                    />
                                    : <div>
                                        <FormGroup>
                                            <Label for="turnOnTime">{I18n[lang].appTurnOnTime}</Label>
                                            {this.renderDateTime('turnOnTime')}
                                            {this.renderClearButton('turnOnTime')}
                                            {this.commonValidator.showErrors('turnOnTime')}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="turnOffTime">{I18n[lang].appTurnOffTime}</Label>
                                            {this.renderDateTime('turnOffTime')}
                                            {this.renderClearButton('turnOffTime')}
                                            {this.commonValidator.showErrors('turnOffTime')}
                                        </FormGroup>
                                        <FormGroup>
                                            <Label for="priceTagUrl">{I18n[lang].priceTagUrl}</Label>
                                            <Input
                                                className="m-auto w-50"
                                                type="text"
                                                placeholder="https://..."
                                                name="priceTagUrl"
                                                id="priceTagUrl"
                                                onChange={this.onInputChange}
                                                value={settings.priceTagUrl}
                                            />
                                            {this.commonValidator.showErrors('priceTagUrl')}
                                        </FormGroup>
                                        <FormGroup>
                                            <Input
                                                type="checkbox"
                                                id="screenBrightnessEnabled"
                                                name="screenBrightnessEnabled"
                                                checked={screenBrightnessEnabled}
                                                onChange={this.onScreenBrightnessEnabledChange}
                                            />
                                            <Label for="screenBrightnessEnabled">{I18n[lang].screenBrightness}</Label>
                                            <Input
                                                className="m-auto p-0 w-50"
                                                type="range"
                                                min="0"
                                                max="100"
                                                step="1"
                                                name="screenBrightness"
                                                id="screenBrightness"
                                                onChange={this.onInputChange}
                                                value={settings.screenBrightness}
                                                disabled={!screenBrightnessEnabled}
                                            />
                                            {this.commonValidator.showErrors('screenBrightness')}
                                        </FormGroup>
                                        <FormGroup>
                                            <Button
                                                color="primary"
                                                type="button"
                                                onClick={this.handleSubmit}>
                                                {I18n[lang].modal.save}
                                            </Button>
                                        </FormGroup>
                                    </div>
                            }
                        </div>
                    </CardBody>
                </Card>
            </div>
        )
    }
}

const mapDispatchToProps = dispatch => {
    return {
        fetchSettings: query => dispatch(fetchPromoterSettings(query)),
        saveSettings: video => dispatch(saveNewPromoterSettings(video)),
        updateSettings: video => dispatch(updateSinglePromoterSettings(video)),
        closeAlert: () => dispatch(closeAlert()),
        changeLocation: url => dispatch(push(url)),
        goBack: () => dispatch(goBack()),
    };
};

const mapStateToProps = state => ({
    alert: state.alert,
    promoterSettings: state.promoterSettings.promoterSettings,
    loading: state.promoterSettings.loading,
    authority: state.currentUser.roles[0].authority || USER_ROLES.GUEST,
    companies: state.companiesReducer.companies,
    company: state.companiesReducer.companies.length > 1 ? {id: 1} : state.companiesReducer.companies[0],
    lang: state.languageReducer.lang
});

export default connect(mapStateToProps, mapDispatchToProps)(PromoterSettings);


// WEBPACK FOOTER //
// ./src/components/Promoter/PromoterSettings/PromoterSettings.js